import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-order-steps',
  templateUrl: './order-steps.component.html',
  styleUrls: ['./order-steps.component.scss'],
})
export class OrderStepsComponent implements OnInit {
  @Input() currentStep: number;
  steps = [
    {
      id: 1, // Nunggu konfirmasi admin (pickup)/tunggu admin input harga ongkir (delivery)
      name: 'pemesanan',
      icon: '../../../assets/icon/pemesanan.svg',
    },
    {
      id: 2, //Nunggu pembayaran dari customer
      name: 'pembayaran',
      icon: '../../../assets/icon/empty-wallet.svg',
    },
    {
      id: 3, //Nunggu verifikasi pembayaran oleh admin
      name: 'verifikasi pembayaran',
      icon: '../../../assets/icon/empty-wallet-tick.svg',
    },
    {
      id: 4, //Proses pembayaran selesai, tahap selanjutnya delivery.
      name: 'pembayaran',
      icon: '../../../assets/icon/pengiriman.svg',
    },
    {
      id: 5, //pengiriman sampai di tujuan/pickup di ambil
      name: 'pengiriman',
      icon: '../../../assets/icon/pengiriman-sampai.svg',
    },
    {
      id: 6, // selesai (saat customer klik selesaikan transaksi)
      name: 'selesai',
      icon: '../../../assets/icon/check.svg',
    },
  ];

  constructor() {}

  ngOnInit() {}

  calculateProgress() {
    let width = '';

    switch (this.currentStep) {
      case 1:
        width = '0%';
        break;
      case 2:
        width = '22%';
        break;
      case 3:
        width = '41%';
        break;
      case 4:
        width = '60%';
        break;
      case 5:
        width = '79%';
        break;
      case 6:
        width = '97%';
        break;
      default:
        width = '0%';
        break;
    }

    return width;
  }
}
